<div *ngIf="twFakeLoadingState" [@finishLoading] class="tw-fake-loading"></div>

<ng-content></ng-content>
